import { GroupManagementGroupDTO } from "@/common/api/models/GroupManagementGroupDTO";

export enum STATUS {
  OPEN = "open",
  PAUSE = "pause",
  END = "end",
}

export const STATUS_NAME = {
  [STATUS.OPEN]: "契約中",
  [STATUS.PAUSE]: "一時停止",
  [STATUS.END]: "契約終了",
};

export const CONTACT_TYPE_PUBLIC = true;
export const CONTACT_TYPE_NOT_PUBLIC = false;

export default class Group {
  id?: number;
  name: string;
  contact_date: string;
  status: string;
  spokes_name: string;
  spokes_email: string;
  request_approved: boolean;
  contact_type: string;
  image_id: string;
  description: string;
  postcode: string;
  address1: string;
  address2: string;
  phone_number: string;
  note: string;
  created_at: string;
  following_members_count: number;
  articles_count: number;
  albums_count: number;
  share_files_count: number;
  image: any;
  constructor(dto?: GroupManagementGroupDTO) {
    if (dto) {
      Object.assign(this, dto);
    } else {
      this.new();
    }
  }

  public new() {
    Object.assign(this, {
      id: null,
      name: null,
      contact_date: null,
      status: STATUS.OPEN,
      spokes_name: null,
      spokes_email: null,
      request_approved: CONTACT_TYPE_PUBLIC,
      contact_type: null,
      image_id: null,
      description: null,
      postcode: null,
      address1: null,
      address2: null,
      phone_number: null,
      note: null,
      created_at: null,
      following_members_count: 0,
      articles: 0,
      albums: 0,
      share_files: 0,
      image: 0,
    });
  }

  get followingMembersNum() {
    return this.following_members_count ?? 0;
  }

  get articlesNum() {
    return this.articles_count ?? 0;
  }

  get albumsNum() {
    return this.albums_count ?? 0;
  }

  get shareFilesNum() {
    return this.share_files_count ?? 0;
  }

  get statusName() {
    return STATUS_NAME[this.status];
  }
}
